<template lang="html">
  <div id="app" class="appLoaded" :class=" appLoadedClass">
      <!-- 在app环境中不显示导航栏 -->
      <div class="topHeader" v-if="!isApp">
        <!-- 微信环境，不显示头部导航。外部看具体页面是否需要头部导航
                showHeader在每个页面设置setHeaders属性 -->
        <aca-header v-show="!isWeixin && showHeader" :customStyleProps="customStyleProps">
          <span v-show="showLeft" slot="left">
            <component :is="headerLeftBackBtn"></component>
          </span>
          <span v-show="!hasSearch" slot="title">{{title}}</span>
          <div v-show="hasSearch" slot="search" class="searchWrap">
            <component :is="searchInput"></component>
          </div>
          <span v-show="showRight" slot="right">
            <component :is="headerRightBtn"></component>
          </span>
        </aca-header>
    </div>
    <div class="mainBox" :style="{paddingTop: (isWeixin || isApp) ? '0px' : '1.173333rem'}">
      <!-- <van-loading /> -->
      <Loading ref="loading" v-show="isShowLoading"/>
      <transition name="fade" mode="out-in" v-on:after-enter="afterEnter">
        <keepAlive :include="cachedComponents" :exclude="noCachedComponents">
            <router-view @setHeader="setHeader" class="etContent" ></router-view>
        </keepAlive>
      </transition>
      <!-- <transition name="fade" mode="out-in" v-on:after-enter="afterEnter">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive && isReloadAlive" class="etContent"
            @setHeader="setHeader"></router-view>
        </keep-alive>
      </transition>
      <transition name="fade" mode="out-in" v-on:after-enter="afterEnter">
        <router-view v-if="!$route.meta.keepAlive && isReloadAlive" class="etContent"
          @setHeader="setHeader"></router-view>
      </transition> -->
    </div>
    <fc-footer v-if="isShowFooter"/>
  </div>
</template>

<script>
import _ from 'lodash'
import router from './router'
import Header from './components/Header.vue'
import { setLocalConfig, getLocalConfig } from '@/utils/storage.js'
// import { isIOS } from '@/utils/ua.js'
import Loading from './components/loading/loading'
import { Footer } from 'smcommon'
import {
    mapState,
} from 'vuex'
import { setTitle, queryKey } from './utils/util.js'
// import browser from './utils/ua.js'
import task from './utils/task'
import eventBus, { SHOW_LOADING } from './utils/eventBus'
// 头部返回按钮
const headerLeftPlaceholder = {
    template: '<van-icon name="arrow-left" @click="back" class="header-arrow-left"/>',
    methods: {
        back () {
            router.back()
        }
    }
}

const routeDirectionForward = 'routeForward'
const routeDirectionBack = 'routeBack'

/* 返回箭头 */
const headerRightPlaceholder = {
    template: '<span v-on:click="back" class="backBtn"></span>',
    methods: {
        back () {
            router.back()
        }
    }
}
/* 小房子 */
const headerHome = {
    template: '<van-icon style="line-height: 46px" name="wap-home-o" v-on:click="back" size="30" />',
    methods: {
        back () {
            router.push({
                path: '/'
            })
        }
    }
}

export default {
    name: 'App',
    provide () {
        return {
            showLoading: this.showLoading,
            hideLoading: this.hideLoading,
            queryKey: this.queryKey
        }
    },
    activated () {
        this.stackLen = this.$router.stack.stack.length
    },
    created () {
        router.onReady(this.routeReady)
        router.beforeEach(this.routeBeforeEach)
        this.stackLen = this.$router.stack.stack.length
        router.afterEach(this.routeAfterEach)
    },
    data () {
        return {
            stackLen: 0,
            isShowLoading: false,
            // isReloadAlive: true,
            title: this.$route.meta.title || '',
            showHeader: true,
            headerLeftBackBtn: headerLeftPlaceholder,
            headerHome: headerHome,
            showLeft: false,
            hasSearch: false,
            searchInput: null,
            showRight: false,
            headerRightBtn: headerRightPlaceholder,
            customStyleProps: { background: '#fff', color: '#333' },
            cachedComponents: router.stack.getKeepAliveViewsName(),
            noCachedComponents: router.stack.getNoKeepAliveViewsName(),
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
            appLoadedClass: ({ appInfo }) => appInfo.appLoadedClass,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isShowFooter () {
            return this.$route.name === 'user'
        },
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        }
    },
    components: {
        'fc-footer': Footer,
        Loading,
        acaHeader: Header,
    },
    mounted () {
        // setTimeout(() => {
        //     this.$setgoindex()
        // }, 3000)
        eventBus.$on(SHOW_LOADING, flag => {
            this.isShowLoading = flag
        })
    },
    methods: {
        queryKey (query, keys) {
            let errmsg = '页面参数有误,请传入正确参数'
            return new Promise((resolve, reject) => {
                if (queryKey(query, keys)) {
                    resolve()
                } else {
                    this.$dialog.alert({
                        message: errmsg,
                    })
                    reject(errmsg)
                }
            })
        },
        // reloaded () {
        //     this.isReloadAlive = false
        //     this.$nextTick(function () {
        //         this.isReloadAlive = true
        //     })
        // },
        setHeader (config) {
            this.setHeaderTitle(config)
            _.extend(this, {
                showHeader: true,
                headerLeftBackBtn: headerLeftPlaceholder,
                showLeft: true,
                hasSearch: false,
                showRight: false,
                headerRightBtn: headerRightPlaceholder,
            }, config)
        },
        // 设置头部
        setHeaderTitle (config) {
            this.$route.meta.title = config.title
            setTitle(config.title || '')
        },
        // 缓存vuex
        saveVuex () {
            const key = 'CARISOK_ALL_STATE'
            if (getLocalConfig(key)) {
                this.$store.replaceState(
                    Object.assign({}, this.$store.state, getLocalConfig(key, 'parse'))
                )
            }
            window.addEventListener('beforeunload', item => setLocalConfig(key, this.$store.state))
        },
        showLoading () {
            this.isShowLoading = true
        },
        hideLoading () {
            this.isShowLoading = false
        },
        routeReady (matchedRoute = {}) {
            matchedRoute && (matchedRoute.meta.update = true)
            if (!router.stack.has(matchedRoute)) {
                router.stack.push(matchedRoute)
                router.stack.cache(matchedRoute)
            } else {
                router.stack.back(matchedRoute)
                // 可能上线版本改 view 组件的 name 。update 来同步下。
                router.stack.update(matchedRoute)
                this.cachedComponents = router.stack.getKeepAliveViewsName()
                this.noCachedComponents = router.stack.getNoKeepAliveViewsName()
            }
        },
        afterEnter () {
            task.resume()
        },

        routeBeforeEach (to, from, next) {
            this.title = to.meta.title || ''
            if (!router.stack.isVisited(to)) {
                router.stack.cache(to)
                // this.showLoading() // 只有没访问过的才 show
            }
            if (!router.stack.has(to)) {
                this.routeDirection = routeDirectionForward
                router.stack.push(to)
            } else if (!router.stack.isLast(to)) {
                this.routeDirection = routeDirectionBack
                router.stack.back(to)
            }

            this.cachedComponents = router.stack.getKeepAliveViewsName()
            this.noCachedComponents = router.stack.getNoKeepAliveViewsName()
            window.requestAnimationFrame(() => {
                next()
            })
        },
        routeAfterEach () {
            const path = router.currentRoute.path
            eventBus.$emit(`active:${path}`)
        }
    },
}
</script>
<style src="./assets/stylus/app.styl" lang="stylus"></style>
